
import Vue from 'vue'
import { Project } from '@/model/Project'
import PagedResults from '@/service/PagedResults'

export default Vue.extend({
  name: 'ParticipateForm',
  props: {
    value: {
      type: Boolean,
    },
    terms: {
      type: String,
    },
    contestId: {
      type: String,
    },
    preselectedProjectSlug: {
      type: String,
    },
  },
  mounted() {
    this.fetchProjects()
  },
  computed: {
    preselectedProjectId: function (): string {
      const result = this.projects.find(
        (element: Project) => element.slug === this.preselectedProjectSlug
      )
      if (result) {
        return result.id
      }
      return ''
    },
  },
  data: () => ({
    projects: [] as Project[],
    projectsLoading: false,
    project: '',
    termsAccepted: false,
    participateLoading: false,
    projectRules: [(v: string) => !!v || 'You must select one project.'],
    termsRules: [(v: boolean) => v || 'You must accept terms and conditions.'],
  }),
  methods: {
    fetchProjects: function () {
      if (!this.$store.state.authentication.signedIn) {
        return
      }
      this.projectsLoading = true
      this.$api
        .get(
          '/users/nickname/' + this.$store.state.authentication.user.nickname
        )
        .then((response) => {
          const projectsLoader = new PagedResults<Project[]>(this.$api)
          projectsLoader
            .all(`/users/${this.$store.state.authentication.user.id}/projects`, 30)
            .then((projects) => {
              this.projects = projects
              if (this.preselectedProjectId) {
                this.project = this.preselectedProjectId
              }
            })
            .finally(() => (this.projectsLoading = false))
        })
    },
    participate: function () {
      this.participateLoading = true
      this.$api
        .post('/contests/applications', {
          contestId: this.contestId,
          projectId: this.project,
        })
        .then((response) => {
          this.$emit('input', false)
          this.$emit('newParticipation')
          this.$store.dispatch(
            'alert/success',
            'Your application is saved and will be checked by our team!'
          )
        })
        .catch(() =>
          this.$store.dispatch(
            'alert/error',
            'Problems with adding your project to the contest.'
          )
        )
        .finally(() => {
          this.participateLoading = false
          const newQuery = { ...this.$route.query };
          delete newQuery.project;
          this.$router.replace({ query: newQuery }).catch(() => {});
        })
    },
  },
  watch: {
    value: function () {
      if (this.value) {
        this.fetchProjects()
        return
      }
      this.projects = []
      ;(this.$refs.participationFormRef as any).resetValidation()
    },
  },
})
